import { ReactElement } from 'react';

import { DocplannerDoctorAddressMapping, DocplannerPractitioner } from '@dreryk/egabinet-docplanner-frontend-api';

import { useInterpolatedTranslationKey } from '@dreryk/react-common';
import { Modal, ModalWidth } from '@dreryk/react-components';

import { doctorsMappingsTranslationKeys } from '../../../translations';
import { PractitionersLoader } from '../PractitionersLoader';

import { AddDoctorAssociationForm } from './AddDoctorAssociationForm';
import { AddDoctorAssociationModalConfirmButton } from './AddDoctorAssociationModalConfirmButton';

type AddDoctorAssociationModalProps = {
   readonly docplannerDoctorId: string;
   readonly docplannerDoctorFirstName: string;
   readonly docplannerDoctorLastName: string;
   readonly doctorAddressMappings: DocplannerDoctorAddressMapping[];
   readonly associatedPractitioner: DocplannerPractitioner | undefined;
   readonly onClose: VoidFunction;
   readonly onAssociationSetSuccess: VoidFunction;
};

export const AddDoctorAssociationModal = (props: AddDoctorAssociationModalProps): ReactElement => {
   const modalTitleTranslationKey = useInterpolatedTranslationKey(
      doctorsMappingsTranslationKeys.editAssociationModalTitle,
      { firstName: props.docplannerDoctorFirstName, lastName: props.docplannerDoctorLastName }
   );
   return (
      <Modal
         testId={'addDoctorAssociation'}
         width={ModalWidth.HUGE}
         onCancel={props.onClose}
         title={modalTitleTranslationKey}
      >
         <PractitionersLoader>
            {({ practitioners }) => (
               <AddDoctorAssociationForm
                  practitioners={practitioners}
                  associatedPractitioner={props.associatedPractitioner}
                  doctorAddressMappings={props.doctorAddressMappings}
               >
                  {({ handleSubmit }) => (
                     <AddDoctorAssociationModalConfirmButton
                        handleSubmit={handleSubmit}
                        docplannerDoctorId={props.docplannerDoctorId}
                        onSuccess={props.onAssociationSetSuccess}
                     />
                  )}
               </AddDoctorAssociationForm>
            )}
         </PractitionersLoader>
      </Modal>
   );
};
